import { useEffect, useState } from 'react';
import { Link, useLocation, useParams } from 'react-router-dom';

function App() {
    const [error, setError] = useState(null);
    const location = useLocation();
    const { tipo } = useParams();

    useEffect(() => {
        if (location.state?.message) {
            setError(location.state.message);

            window.history.replaceState({}, document.title);
        }
    }, [location.state]);

    return (
        <section className="w-full bg-secondary bg-opacity-15">
            <div className="grid grid-cols-12 gap-4">
                <div className="col-span-12">
                    <div className="flex h-screen items-center justify-center gap-4">
                        <div>
                            <h3 className="text-6xl font-bold mb-4">Oops...</h3>
                            <h5 className="text-2xl text-secondary mb-4">Parece que algo está errado</h5>
                            <h6>{error?.text ?? 'Parece que estamos com um problema'}</h6>
                            <h6>Por favor, visite a nossa página inicial</h6>

                            <Link
                                to="/"
                                className="inline-block px-8 py-2 bg-primary text-xl text-white font-bold uppercase hover:bg-opacity-90 mt-10"
                            >
                                Voltar
                            </Link>
                        </div>
                        {tipo === '403' ? (
                            <img alt='erro 403' src={`/assets/img/error-403.svg`} className="w-1/2 max-w-2xl" />
                        ) : (
                            <img alt='erro 404' src={`/assets/img/error-404.svg`} className="w-1/2 max-w-2xl" />
                        )}
                    </div>
                </div>
            </div>
        </section>
    );
}

export default App;
